export const arrayToString = (arr, separator) => {
  if (arr.length > 0) {
    return arr.join(separator);
  }
  return '-'
}